module.exports = __webpack_public_path__ + "static/img/shirt.2e136f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/join/shirt.png
// module id = jUm0
// module chunks = 3